/**
 * Redux store default values.
 *
 * @summary Store default values for reducers.
 * @author Alvear Candia, Cristopher Alejandro <caalvearc@achs.cl>
 *
 * Created at     : 2020-05-16 22:44:51
 * Last modified  : 2020-11-29 18:49:59
 */

// sample data defaults.
export const SampleDefaults = {
    user: null
};

export const UserDefaults = {
    data: null
};


export const NotificationDefaults = {
    data: null
};